import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetEdc_sharing_groupId = z.any()
export type TagsGetEdc_sharing_groupId = z.infer<typeof tagsGetEdc_sharing_groupId>

export const paramsGetEdc_sharing_groupId = z.object({ "groupId": z.string() })
export type ParamsGetEdc_sharing_groupId = z.infer<typeof paramsGetEdc_sharing_groupId>

export const querystringGetEdc_sharing_groupId = z.object({ "from": z.string().date().optional(), "to": z.string().date().optional(), "granularity": z.union([z.literal("interval"), z.literal("day"), z.literal("month")]).optional() })
export type QuerystringGetEdc_sharing_groupId = z.infer<typeof querystringGetEdc_sharing_groupId>

export const responseGetEdc_sharing_groupId = z.object({ "payload": z.object({ "totals": z.object({ "generation": z.number(), "consumption": z.number(), "shared": z.number(), "received": z.number(), "exported": z.number(), "purchased": z.number(), "missed": z.number() }), "intervalCount": z.number(), "excludedIntervals": z.number(), "points": z.array(z.record(z.any()).and(z.intersection(z.object({ "ean": z.string(), "role": z.string(), "name": z.string() }), z.object({ "key": z.string(), "measured": z.number(), "after": z.number(), "shared": z.number(), "missed": z.number() })))), "series": z.array(z.record(z.any()).and(z.intersection(z.object({ "period": z.string() }), z.object({ "generation": z.number(), "consumption": z.number(), "shared": z.number(), "received": z.number(), "exported": z.number(), "purchased": z.number(), "missed": z.number() })))), "defaultKeys": z.record(z.number().gte(0).lte(1)).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.number().gte(0).lte(1).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}), "allocationKeys": z.union([z.record(z.number().gte(0).lte(1)).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.number().gte(0).lte(1).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}), z.null()]), "efficiencySettings": z.object({ "thresholdPercent": z.number().gte(0).lte(100), "startHour": z.number().int().gte(0).lte(23), "endHour": z.number().int().gte(1).lte(24), "maxExportKw": z.number().gte(0).lte(1000000).optional() }), "from": z.union([z.string(), z.null()]), "to": z.union([z.string(), z.null()]) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetEdc_sharing_groupId = z.infer<typeof responseGetEdc_sharing_groupId>

interface IGetEdc_sharing_groupId extends BaseMethodType {
  tags: TagsGetEdc_sharing_groupId,
  params: ParamsGetEdc_sharing_groupId,
  querystring: QuerystringGetEdc_sharing_groupId,
  response: ResponseGetEdc_sharing_groupId
}
export const URL = '/edc-sharing/:groupId'
export const validation = {
  get: {
    tags: tagsGetEdc_sharing_groupId,
    params: paramsGetEdc_sharing_groupId,
    querystring: querystringGetEdc_sharing_groupId,
    response: responseGetEdc_sharing_groupId
  }
}
export interface Edc_sharing_groupId extends BaseRouteType {
  get: IGetEdc_sharing_groupId
}